import { BehaviorSubject } from "rxjs";
import { ILearningExperience, Service } from "../../../symphony";

@Service()
export class AICoursesStore {
  public courses = new BehaviorSubject<ILearningExperience[]>([]);
}
